import utils from 'utils'

class cancelInvoiceDetailCtrl {
    constructor($scope, httpRequest, $stateParams, globalFn, scrollService, $state) {
        const userInfo = $scope.userInfo || {}
        $scope.ukeyList = userInfo.sysUkeyList
        $scope.dictData = {}
        const types = ['ovat_tax_rate']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        // 隐藏一二级菜单
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', () => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })

        const {
            invoiceId
        } = $stateParams
        utils.loading('正在加载数据，请耐心等待......')

        function getwaitListpage(pageInfo) {
            httpRequest.post_getPageInvoiceDetail(pageInfo).then((res) => {
                $scope.currentDetail = null
                $scope.currentDetail = res.data.value
                if ($scope.currentDetail.isLastPage && $scope.currentDetail.size < 20) {
                    $scope.newDetails = $scope.newDetails ? $scope.newDetails.concat($scope.currentDetail.list) : [].concat($scope.currentDetail.list)
                } else {
                    $scope.newDetails = []
                    $scope.newDetails = $scope.currentDetail.list
                }
                utils.loaded()
            })
        }
        $scope.loadSize = 50 // 默认一次跨度200条
        $scope.pageParam = {
            pageNum: 1,
            pageSize: $scope.loadSize,
            param: {
                invoiceID: invoiceId,
            },
        }
        httpRequest.post_getOvatInvoice(invoiceId).then((res) => {
            $scope.param = res.data.value
            $scope.param.saleBank = $scope.param.saleBank + ' ' + $scope.param.saleBankAccount
            $scope.param.saleAddress = $scope.param.saleAddress + ' ' + $scope.param.salePhone
            if ($state.current.name.indexOf('cancelInvoice.detail') > -1) {
                $scope.param.showBillCode = true
            }
            
            taxChange('0')
            $scope.adValoremTotalChinese = globalFn.digitUppercase($scope.param.adValoremTotal)
            // 开票点数据
            if ($scope.ukeyList != null && $scope.ukeyList.length > 0) {
                for (let i = 0, l = $scope.ukeyList.length; i < l; i++) {
                    if ($scope.ukeyList[i].ukeyId === $scope.param.ukeyId) {
                        $scope.param.ukeyName = $scope.ukeyList[i].ukeyName
                    }
                }
            }
            getwaitListpage($scope.pageParam)
            utils.loaded()
        })
        // edit by fwc----->
        $scope.onScrollTop = function () {
            $scope.pageParam = scrollService.onScrollTop($scope.currentDetail, $scope.pageParam, $scope.loadSize, getwaitListpage)
        }
        $scope.onScrollDown = function () {
            $scope.pageParam = scrollService.onScrollDown($scope.currentDetail, $scope.pageParam, $scope.loadSize, getwaitListpage)
        }
        // 是否含税
        $scope.isTaxChange = taxChange

        function taxChange(v) {
            $scope.param.isTax = v
            if ($scope.param.isTax === '0') {
                $scope.isTaxText = '不含税'
            } else {
                $scope.isTaxText = '含税'
            }
        }
    }
}
cancelInvoiceDetailCtrl.$inject = ['$scope', 'httpRequest', '$stateParams', 'globalFn', 'scrollService', '$state']
export default cancelInvoiceDetailCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/cancelInvoiceDetailCtrl.js